module.exports = "/wwwroot/img/WMS.png?ver=8cc6e29f";